import { render, staticRenderFns } from "./DevolucionRecepcionComponent.vue?vue&type=template&id=6e5162bd&"
import script from "./DevolucionRecepcionComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionRecepcionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports